import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductGalleryComponent } from './product-gallery.component';
import { SharedModule } from '../../shared/shared.module';
import { CarouselComponent } from './carousel/carousel.component';
import { CarouselFluidComponent } from './carousel-fluid/carousel-fluid.component';
import { GalleryControllerComponent } from './gallery-controller/gallery-controller.component';
import { MapComponent } from './map/map.component';
import { AgmCoreModule } from '@agm/core';
import { CommonsLibModule } from 'commons-lib';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { ModalComponent } from './modal/modal.component';
import { ThumbnailComponent } from './thumbnail/thumbnail.component';



@NgModule({
  declarations: [ProductGalleryComponent, CarouselComponent, CarouselFluidComponent, GalleryControllerComponent, MapComponent, ModalComponent, ThumbnailComponent],
  imports: [
    CommonModule,
    SharedModule,
    CommonsLibModule,
    NgZorroAntdModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDJ5WMmnDTMFiF5BdYaLeQ1aAUFMWRxw0Q'
    }),
  ],
  exports: [ProductGalleryComponent]
})
export class ProductGalleryModule { }
